/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  PublicContact,
  PublicContactFromJSON,
  PublicContactToJSON,
  PublicProgramType,
} from './'

/**
 *
 * @export
 * @interface PublicProgram
 */
export interface PublicProgram {
  /**
   *
   * @type PublicProgramType
   * @memberof PublicProgram
   */
  type: PublicProgramType
  /**
   * The day of the week the program is available. Where 1 is Monday and 7 is Sunday
   * @type number
   * @memberof PublicProgram
   */
  dayOfTheWeek?: number
  /**
   * The starting time for the program using ISO standard 24 hour format: `hh:mm`.
   * @type string
   * @memberof PublicProgram
   */
  startTime?: string
  /**
   * The ending time for the program using ISO standard 24 hour format: `hh:mm`.
   * @type string
   * @memberof PublicProgram
   */
  endTime?: string
  /**
   *
   * @type PublicContact
   * @memberof PublicProgram
   */
  director?: PublicContact
}

export function PublicProgramFromJSON(json: any): PublicProgram {
  return PublicProgramFromJSONTyped(json, false)
}

export function PublicProgramFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicProgram {
  if (json === undefined || json === null) {
    return json
  }
  return {
    type: json['type'],
    dayOfTheWeek: !exists(json, 'dayOfTheWeek')
      ? undefined
      : json['dayOfTheWeek'],
    startTime: !exists(json, 'startTime') ? undefined : json['startTime'],
    endTime: !exists(json, 'endTime') ? undefined : json['endTime'],
    director: !exists(json, 'director')
      ? undefined
      : PublicContactFromJSON(json['director']),
  }
}

export function PublicProgramToJSON(value?: PublicProgram | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    type: value.type,
    dayOfTheWeek: value.dayOfTheWeek,
    startTime: value.startTime,
    endTime: value.endTime,
    director: PublicContactToJSON(value.director),
  }
}
